import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {FilterChip} from 'views/module';

const FilterChipOption = (props) => {
  const selection = props.selection;
  const filterOptions = props.filterOptions;
  const updateFilter = props.updateFilter;

  const filter = selection.filter;

  const handleClick = (filter, item) => {
    updateFilter(filter, item);
  };

  const handleDelete = (filter) => {
    updateFilter(filter, null);
  };

  const sortedOptions = Object.values(filterOptions)
      .sort((a, b) => {
        return a.rank - b.rank;
      });

  return (
    <>
      {
        sortedOptions.map((filteredOption) => {
          const optionKey = filteredOption.key;

          const filterOption = filter[optionKey];
          if (filterOption) {
            const filterData = filterOption.filterData;
            const multiSelect = filterData.multiSelect;

            const optionSelected = filterOption.optionSelected;

            let filterSelected;
            if (multiSelect) {
              filterSelected = optionSelected.map((e) => filterData.options[e]);
            } else if (filterData.type === 'text') {
              filterSelected = {key: optionSelected, label: optionSelected};
            } else {
              filterSelected = filterData.options[optionSelected];
            }
            return (
              <Box
                sx={{p: 0.5}}
                key={optionKey}
              >
                <FilterChip
                  filter={filteredOption}
                  filterSelected={filterSelected}
                  onClick={handleClick}
                  onDelete={() => handleDelete(filterData)}
                />
              </Box>
            );
          } else {
            return null;
          }
        })
      }
    </>
  );
};

FilterChipOption.propTypes = {
  selection: PropTypes.object.isRequired,
  filterOptions: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
};


export default React.memo(FilterChipOption);
